import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'
import Button from '../../shared/components/Button'

export default class ReleaseControls extends Component {

  static propTypes = {
    allDirtyFieldsResolved: PropTypes.bool,
    allFieldsRejected: PropTypes.bool,
    isBusy: PropTypes.bool,
    isRejecting: PropTypes.bool,
    isRejectingField: PropTypes.bool,
    isReleaseable: PropTypes.bool,
    onAbort: PropTypes.func,
    onDelete: PropTypes.func,
    onReject: PropTypes.func,
    onRejectionMessageChange: PropTypes.func,
    onSave: PropTypes.func,
    reasonPlaceholder: PropTypes.string,
    rejectionMessage: PropTypes.string,
    shouldDelete: PropTypes.bool,
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isRejecting && this.props.isRejecting && this.textareaRef) {
      const value = this.textareaRef.value
      const REASON_PLACEHOLDER = this.props.reasonPlaceholder
      const startPos = value.indexOf(REASON_PLACEHOLDER)
      const endPos = startPos + REASON_PLACEHOLDER.length
      this.textareaRef.selectionStart = startPos
      this.textareaRef.selectionEnd = endPos
      this.textareaRef.focus()
    }
  }

  // eslint-disable-next-line complexity
  render() {
    const {
      allFieldsRejected,
      allDirtyFieldsResolved,
      isBusy,
      isRejecting,
      isRejectingField,
      isReleaseable,
      onAbort,
      onReject,
      onRejectionMessageChange,
      onSave,
      onDelete,
      rejectionMessage,
      shouldDelete
    } = this.props

    return (
      <div className={classNames('vertical', 'fixed', 'release-controls', {
        reject: isRejecting
      })}
      >
        <div className="alert alert-danger" />
        <div className="horizontal form-container buttons">

          <Button
            onClick={onReject}
            className="btn btn-danger"
            disabled={
              !(isReleaseable
              && isRejecting ? rejectionMessage.length : true)
            }
            busy={isBusy}
          >
            {isRejecting ? 'Jetzt abschicken' : 'Ablehnen'}
          </Button>

          <Button
            className={classNames('btn btn-default cancel', { visible: true /*isRejecting*/ })}
            onClick={onAbort}
          >
            {isRejecting ? 'Ablehnen abbrechen' : 'Abbrechen'}
          </Button>

          {shouldDelete
            ? (
              <Button
                className="btn btn-danger pull-right"
                disabled={
                  // disable if the item...
                  //
                  // ... is not releasable
                  !isReleaseable
              // ... is already in rejection mode
              || isRejecting
              // ... is rejecting at least one field
              || isRejectingField
              // ... all fields are to be rejected at once
              || allFieldsRejected
              // ... not all dirty tabs have been opend yet
              || !allDirtyFieldsResolved
                }
                onClick={onDelete}
                icon="trash"
                busy={isBusy}
              >
                Endgültig löschen
              </Button>
            )
            : (
              <Button
                className="btn btn-primary pull-right"
                disabled={
                  // disable if the item...
                  //
                  // ... is not releasable
                  !isReleaseable
              // ... is already in rejection mode
              || isRejecting
              // ... is rejecting at least one field
              || isRejectingField
              // ... all fields are to be rejected at once
              || allFieldsRejected
              // ... not all dirty tabs have been opend yet
              || !allDirtyFieldsResolved
                }
                onClick={onSave}
                icon="ok"
                busy={isBusy}
              >
                Online stellen
              </Button>
            )}

          {isRejectingField
            ? (
              <span className="help-block pull-right">
                Online stellen nicht möglich, da mindestens ein Feld abgelehnt wurde.&nbsp;
              </span>
            )
            : null}

          {(!isRejectingField && !allDirtyFieldsResolved)
            ? (
              <span className="help-block pull-right">
                Vor dem Online stellen müssen alle Schritte mit Änderungen einmal geöffnet worden sein.&nbsp;
              </span>
            )
            : null}

        </div>
        <div className="buttons reject-all">
          <div className="arrow" />
          <div className="form-group">
            <label htmlFor="reject-all-message">Ablehnungsgrund</label>
            <textarea
              className="form-control"
              name="reject-all-message"
              rows="5"
              value={rejectionMessage}
              onChange={onRejectionMessageChange}
              autoFocus
              ref={(ref) => {
                this.textareaRef = ref
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/release/components/ReleaseControls.js